<template>
    <a
        :href="url"
        :class="[
            'rounded-2xl border border-stone-200 p-5 hover:border-gray-300 hover:bg-stone-50',
            {
                'text-left md:text-right': isTextAlignedRight,
            },
        ]"
    >
        <p class="text-xs uppercase tracking-[0.2em] text-gray-500">
            {{ label }}
        </p>
        <p class="mt-3 text-lg font-medium text-gray-900">
            {{ title }}
        </p>
    </a>
</template>

<script setup lang="ts">
    interface BlogPostNavigationLinkProps {
        label: string
        title: string
        url: string
        isTextAlignedRight?: boolean
    }

    defineProps<BlogPostNavigationLinkProps>()
</script>
